import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FilterOption } from '../search-types'

@Component({
    selector: 'app-search-options',
    templateUrl: './search-options.component.html',
    styleUrls: ['./search-options.component.scss'],
})
export class SearchOptionsComponent implements OnInit {
    @Input() filters: FilterOption[] = []
    @Input() selectedFilterType!: string
    @Output() onOptionChange = new EventEmitter<FilterOption>()

    currentFilterType: string | null = null

    constructor() {}

    ngOnInit(): void {
        this.setDefaultFilter()
    }

    private setDefaultFilter() {
        if (this.selectedFilterType) {
            this.currentFilterType = this.selectedFilterType
        }
    }

    private getCurrentFilterOptionByType() {
        return this.filters.find(option => option.type === this.currentFilterType)
    }

    public onFilterOptionChange() {
        this.onOptionChange.emit(this.getCurrentFilterOptionByType())
    }
}
